import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import BoardStats from 'components/molecules/Board/BoardStats';
import {
	actionCreators,
	getActivities,
	getCalories,
	getCoachMotivation,
	getDaysStats,
	getTodoStats,
} from 'store/dashboard';
import { getCoach } from 'store/profile';

const mapStateToProps = (state: any) => ({
	calories: getCalories(state),
	todos: getTodoStats(state),
	activities: getActivities(state),
	days: getDaysStats(state),
	motivation: getCoachMotivation(state),
	coach: getCoach(state),
});

// TODO: Remove AC's
const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({ ...actionCreators }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(BoardStats as any);
